import { DarkTheme, DefaultTheme, ThemeProvider } from '@react-navigation/native';
import { Stack } from 'expo-router';
import * as SplashScreen from 'expo-splash-screen';
import * as Updates from 'expo-updates';
import { StatusBar } from 'expo-status-bar';
import { useEffect } from 'react';
import 'react-native-reanimated';

import { useColorScheme } from '@/hooks/use-color-scheme';

export const unstable_settings = {
  anchor: '(tabs)',
};

export default function RootLayout() {
  const colorScheme = useColorScheme();

  useEffect(() => {
    const hideSplash = () => {
      SplashScreen.hideAsync().catch((error) => {
        console.log('Erreur fermeture splash :', error);
      });
    };
    const hideTimer = setTimeout(hideSplash, 250);

    hideSplash();

    return () => {
      clearTimeout(hideTimer);
    };
  }, []);

  useEffect(() => {
    if (__DEV__ || !Updates.isEnabled) {
      return undefined;
    }

    let cancelled = false;
    const syncLatestUpdate = async () => {
      try {
        const update = await Updates.checkForUpdateAsync();

        if (!cancelled && update.isAvailable) {
          await Updates.fetchUpdateAsync();

          if (!cancelled) {
            await Updates.reloadAsync();
          }
        }
      } catch (error) {
        console.log('Erreur synchronisation update EAS :', error);
      }
    };
    const updateTimer = setTimeout(syncLatestUpdate, 1200);

    return () => {
      cancelled = true;
      clearTimeout(updateTimer);
    };
  }, []);

  return (
    <ThemeProvider value={colorScheme === 'dark' ? DarkTheme : DefaultTheme}>
      <Stack>
        <Stack.Screen name="(tabs)" options={{ headerShown: false }} />
        <Stack.Screen name="join/index" options={{ headerShown: false }} />
        <Stack.Screen name="join/[code]" options={{ headerShown: false }} />
        <Stack.Screen name="modal" options={{ presentation: 'modal', title: 'Modal' }} />
      </Stack>
      <StatusBar style="auto" />
    </ThemeProvider>
  );
}
